import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { formatNumber } from '../utils/helpers'

interface Props {
	quantity: number|undefined|null;
	unit: string;
	description: string;
}

const MeterWrapper = styled.div`
	margin-bottom: 1em;
`;

const Unit = styled.div`
	font-size: 3rem;
	text-align: center;
	font-family: var(--font-family-secondary);
`;

const Desc = styled.div`
	font-size: 1rem;
	text-align: center;
	margin: auto;
`;

export const Meter: React.FC<Props> = (props: Props) => (
	<MeterWrapper>
		{!_.isNil(props.quantity) && !isNaN(props.quantity) &&
			<div>
				<Unit>
					{formatNumber(props.quantity, 3)}
					{props.unit}
				</Unit>
				<Desc>{props.description}</Desc>
			</div>
		}
		{(_.isNil(props.quantity) || isNaN(props.quantity)) && <h4>Ei käyttötietoja</h4>}
	</MeterWrapper>
);